import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=477df4ac"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"
import style0 from "./Queue.vue?vue&type=style&index=0&id=477df4ac&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477df4ac')) {
      api.createRecord('477df4ac', component.options)
    } else {
      api.reload('477df4ac', component.options)
    }
    module.hot.accept("./Queue.vue?vue&type=template&id=477df4ac", function () {
      api.rerender('477df4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/Queue.vue"
export default component.exports